import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface Health {
  Diabetes: string,
  Hypertension: string,
  Language: string,
  Lmp: string | null,
  NewPatient: string,
  Osteoporosis: string,
  Pregnant: string,
  RheumatoidArthritis: string,
  Smoker: string
}

export interface MemberInfo {
  CompanyId: string,
  MembMpiNo: string
}

export const saveHealth = (health: Health, memberInfo: MemberInfo) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityHealth.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_HEALTH_REQUEST });

  const memberHealth = {
    MembMpiNo: memberInfo.MembMpiNo,
    CompanyId: memberInfo.CompanyId,
    NewPatient: health.NewPatient,
    Language: health.Language,
    Diabetes: health.Diabetes,
    Hypertension: health.Hypertension,
    Osteoporosis: health.Osteoporosis,
    RheumatoidArthritis: health.RheumatoidArthritis,
    Smoker: health.Smoker,
    Pregnant: health.Pregnant,
    Lmp: health.Lmp,
  };

  return api.eligibility.health.save(memberHealth)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_HEALTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_HEALTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

